import {
  DeploymentDetailsInfo,
  GroupDeploymentDetailsResponse,
} from '../../types/deployment/DeploymentDetailsInfo';
import {request} from '../request';

export const DeploymentDetailsUrl = '/deployment/details';
export const DeploymentGroupDetailsUrl = '/deployment/group/details';

export type DeploymentDetailsRequest = {
  deploymentId: string;
};

export async function getDeploymentDetails(params: DeploymentDetailsRequest) {
  return request<DeploymentDetailsInfo>({
    method: 'get',
    url: DeploymentDetailsUrl,
    params,
  });
}

export type GroupDeploymentDetailsRequest = {
  applicationId: string;
  targetDeviceGroupId: string;
};

export async function getDeviceGroupDeploymentDetails(
  params: GroupDeploymentDetailsRequest
) {
  return request<GroupDeploymentDetailsResponse['body']>({
    method: 'get',
    url: DeploymentGroupDetailsUrl,
    params,
  });
}
